var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog-box'),_c('api-errors'),_c('cmh-landing-page-step',{attrs:{"comingFromOresWebSite":"","lang":_vm.lang},on:{"canContinue":function($event){_vm.canContinue = $event},"next":_vm.nextStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }